import React from 'react';
import ProfitresultsStaticsContainer from '../../containers/profitresults_statics/ProfitresultsStaticsContainer';
import BreadcrumbsContainer from '../../containers/common/breadcurmbs/BreadcrumbsContainer';

const ProfitresultsStaticsPage = () => {
  return (
    <>
      <BreadcrumbsContainer title="경영정보/사업목표vs이익실적" icon="statistics" />
      <ProfitresultsStaticsContainer />
    </>
  );
};

export default ProfitresultsStaticsPage;
